module.exports = __webpack_public_path__ + "static/media/Andrina 6.f4d0f250.png";